"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_RFP_DATA_COLLECTION = exports.DEFAULT_FINAL_NEGOTIATION_MEETING = exports.DEFAULT_HAND_OVER_MEET = exports.DEFAULT_KDM_MEETING_PURPOSE = exports.MEETING_STATUS_SCHEDULED = exports.MEETING_SUBTYPE_KDM_KEY = exports.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS = exports.INSURER_MAP_TABLE_DELETE_FIELDS = exports.TPA_MAP_TABLE_DELETE_FIELDS = exports.BROKER_MAP_TABLE_DELETE_FIELDS = exports.COMPANY_MAP_TABLE_DELETE_FIELDS = exports.FILE_UPLOAD_TABLE_DELETE_FIELDS = exports.CONTACT_RECORD_TYPE_MAP = exports.CONTACT_MAP_TABLE_DELETE_FIELDS = exports.TASK_CLOSED = exports.TASK_TYPE_APPROVAL = exports.TASK_STATUS_CLOSED = exports.TASK_STATUS_ACTIVE = exports.ACL_CATEGORY = exports.ACL_ACTIONS = exports.TASK_TYPE = exports.TASK_CATEGORY_ACTIVITY = exports.OPPORTUNITY_STATUS_WORK_IN_PROGRESS = exports.OPPORTUNITY_STATUS_LOST = exports.OPPORTUNITY_STATUS_OPEN = exports.MANDATE_TYPE_FULL_MANDATE = exports.ACTIVITY_APPROVAL_YES = exports.PRIORITY_LOOK_UP_HIGH_VALUE = exports.PRIORITY_LOOK_UP_MEDIUM_VALUE = exports.DATA_VALIDATION_TASK_NAME = exports.POLICY_PLACED_TYPE = exports.sortRealtionsMapping = exports.bypassAuthGuardApis = exports.bypassAclGuardApis = exports.meetingSearchObject = exports.noteSearchObject = exports.taskSearchObject = exports.employeeSearchObject = exports.contactSearchObject = exports.opportunitySearchObject = exports.BrokerSearchObject = exports.InsurerSearchObject = exports.TpaSearchObject = exports.companySearchObject = exports.PRIORITY_LOOK_UP = exports.ATTRIBUTE_FIELD_MAP = exports.GROUP_COMPANY = exports.COMPANY_STATUS_KEY = exports.DEFAULT_MESSAGES = exports.DEFAULT_VALUES = void 0;
exports.NOTIFICATION_EVENT_TYPES = exports.OPPORTUNITY_ACTIVITY_STATUS = exports.PRIORITY_VIMP = exports.PRIORITY_HIGH = exports.PRIORITY_IMP = exports.NOTIFICATION_COMPANY_ENTITY = exports.NOTIFICATION_OPPORTUNITY_ENTITY = exports.OPTY_SUM_INSURED_NOTIFICATION_THRESHOLD = exports.COMPANY_SUM_INSURED_NOTIFICATION_THRESHOLD = exports.PRIORITY_COMPANY_CREATION = exports.OPPORTUNITY_PARTICIPANT_INVITE = exports.PASSWORD_RESET_EVENT = exports.NOTIFICATION_STATUS_DELETE = exports.NOTIFICATION_STATUS_UNREAD = exports.NOTIFICATION_STATUS_READ = exports.NOTIFICATION_FAILED = exports.NOTIFICATION_SUCCESS = exports.NOTIFICATION_IN_APP = exports.NOTIFICATION_SMS = exports.NOTIFICATION_EMAIL = exports.COVER_TYPE = exports.PREMIUM_CALCULATION = exports.iirm = exports.DEFAULT_PLACEMENT_SLIP_GENERATION = exports.DEFAULT_RFP_DETAILS_ENTRY = void 0;
exports.DEFAULT_VALUES = {
    CREATED_BY: "SYSTEM",
    UPDATED_BY: "SYSTEM",
    ADDRESS_ID: 1, // Default address ID for InsurerAddress
    PAGE: 1, // Default page number for pagination
    LIMIT: 10, // Default number of records per page
    SORT_BY: "id", // Default field to sort by
    SORT_ORDER: "DESC", // Default sort order
    ACTIVE_USER_STATUS: "USER_STATUS_ACTIVE", // Default status for active users
    USER_ENTITY: "user",
    STATUS_LOOKUP: "statusLid",
    USER_STATUS_KEY: "userStatusKey"
};
exports.DEFAULT_MESSAGES = {
    INSURER_CREATED: "Insurer successfully created.",
    INSURERS_RETRIEVED: "Insurers successfully retrieved.",
    INSURER_RETRIEVED: "Insurer successfully retrieved.",
    INSURER_UPDATED: "Insurer successfully updated.",
    INSURER_DELETED: "Insurer successfully deleted.",
    INSURER_NOT_FOUND: "Insurer not found.",
    INTERNAL_SERVER_ERROR: "Internal server error.",
    INVALID_INPUT: "Invalid input provided.",
    ADDRESSES_RETRIEVED: "Addresses with insurers successfully retrieved.",
};
exports.COMPANY_STATUS_KEY = {
    ACTIVE: "COMPANY_STATUS_ACTIVE",
    DELETED: "COMPANY_STATUS_DELETED",
    UNDER_REVIEW: "COMPANY_STATUS_UNDER_REVIEW",
};
exports.GROUP_COMPANY = {
    Name: "GROUP_COMPANY",
    keyValue: "NO",
};
exports.ATTRIBUTE_FIELD_MAP = {
    companyType: "companyType.lookUpValue",
    industrySegment: "industrySegment.lookUpValue",
    city: "companyAddresses.address.cityId.name",
    country: "companyAddresses.address.countryId.name",
    cityId: "insurerAddresses.address.cityId.name",
    priority: "priority.lookUpValue",
    sentiment: "sentiment.lookUpValue",
    companyTag: "companyTag.lookUpValue",
    department: "department",
    owner: "owner.firstName",
    designation: "designation",
    email: "communicationDetails.communicationDetails",
    phone: "communicationDetails.communicationDetails",
    contactName: "firstName",
    organisationName: "companyContactMaps.company.companyName",
    status: "status.lookUpValue",
    // branch: "companyContactMaps.company.companyAddress.address.cityId.name",
    leadCrm: "leadCrmInfo.firstName",
    branch: "companyContactMaps.company.companyAddresses.address.cityId.name",
    opportunityIndustrySegmentId: "company.industrySegment.id",
    opportunityIndustrySegment: "company.industrySegment.lookUpValue",
    opportunityContact: "opportunityContactMap.contact.id",
    opportunityPriority: "company.priority.lookUpValue",
    opportunityBranch: "opportunityRiskLocations.address.cityId.name",
    opportunityCreationDate: "createdAt",
    opportunityStage: "stage.lookUpValue",
    opportunityPolicyType: "policyType.lookUpValue",
    opportunityAssignedTo: "createdBy",
    employeeFirstName: "firstName",
    employeeDesignation: "designation.name",
    employeeDepartment: "department.name",
    employeeOrganisation: "organisation.name",
    companyName: "company.companyName",
    industry: "company.industrySegment.lookUpValue",
    employeeRole: "role.name",
    employeeLocation: "location.name",
    employeeVertical: "vertical.name",
    employeeBranch: "branch.name",
    employeeIworkRole: "iworkRole.lookUpValue",
    insurerAddresses: "insurerAddresses.address.address1",
    stateId: "insurerAddresses.address.stateId.name",
    contact: "opportunityContactMap.contact.displayName",
    tpaAddresses: "tpaAddresses.address.address1",
    phoneNumber: "tpaAddresses.address.phoneNumber",
    opportunityType: "opportunityType.lookUpValue",
    meetingType: "meetingType.lookUpValue",
    ownedBy: "createdBy",
};
exports.PRIORITY_LOOK_UP = {
    value: "priority.lookUpValue",
    order: "priority.lookUpOrder",
};
exports.companySearchObject = [
    "displayName",
    "companyName",
    "companyAddresses.address.cityId.name",
    "companyAddresses.address.countryId.name",
    "companyType.lookUpValue",
    "priority.lookUpValue",
];
exports.TpaSearchObject = [
    "tpaName",
    "tpaAddresses.address.cityId.name",
];
exports.InsurerSearchObject = [
    "insurerName",
    "companyTag.lookUpValue",
    "insurerAddresses.address.cityId.name",
];
exports.BrokerSearchObject = [
    "brokerName",
    "brokerAddresses.address.cityId.name",
];
exports.opportunitySearchObject = ["company.companyName"];
exports.contactSearchObject = [
    "firstName",
    "middleName",
    "lastName",
    "companyContactMaps.company.companyName",
    "communicationDetails.communicationDetails",
    "status.lookUpValue",
    "tag.lookUpValue",
    "department",
    "designation",
];
exports.employeeSearchObject = ["firstName"];
exports.taskSearchObject = ["taskName"];
exports.noteSearchObject = ["title", "description"];
exports.meetingSearchObject = [
    "meetingSubject",
    "meetingAgenda",
];
exports.bypassAclGuardApis = [
    "/login",
    "/user-details",
    "/health",
    "/access-control-list/permissions",
    "/employee/password-reset/validate",
    "/employee/password-reset",
    "/employee/password-reset-mail",
    "/notifications",
    "/notifications/check-latest-notification",
    "/notifications/update-status",
];
exports.bypassAuthGuardApis = [
    "/login",
    "/register",
    "/health",
    "/employee/password-reset/validate",
    "/employee/password-reset",
    "/employee/password-reset-mail",
];
exports.sortRealtionsMapping = {
    PARENT_COMPANY_INDUSTRY_SORT: "company.industrySegment.lookUpValue",
    PARENT_COMPANY_INDUSTRY_SORT_KEY: "industrySegment.lookUpValue",
    PARENT_PRIORITY_SORT: "company.priority.lookUpOrder",
    PARENT_PRIORITY_SORT_KEY: "priority.lookUpValue",
    PARENT_BRANCH_SORT_KEY: "companyContactMaps.company.companyAddresses.address.cityId.name",
    PARENT_COMPANY_SORT: "companyName",
    PARENT_COMPANY_NAME_SORT_KEY: "company.companyName",
    PARENT_INSURER_CITY_SORT_KEY: "companyAddresses.address.cityId",
    PARENT_INSURER_CITY_SORT: "insurerAddress.address.cityId.name",
    PARENT_TPA_CITY_SORT_KEY: "insurerAddresses.address.cityId.name",
    PARENT_TPA_CITY_SORT: "tpaAddresses.address.cityId.name",
    PARENT_TPA_STATE_SORT_KEY: "insurerAddresses.address.stateId.name",
    PARENT_TPA_STATE_SORT: "tpaAddresses.address.stateId.name",
    PARENT_INSURER_PHONE_NUMBER_SORT_KEY: "tpaAddresses.address.phoneNumber",
    PARENT_INSURER_PHONE_NUMBER_SORT: "insurerAddresses.address.phoneNumber",
    PARENT_BROKER_CITY_SORT_KEY: "insurerAddresses.address.cityId.name",
    PARENT_BROKER_CITY_SORT: "brokerAddresses.address.cityId.name",
    PARENT_BROKER_STATE_SORT_KEY: "insurerAddresses.address.stateId.name",
    PARENT_BROKER_STATE_SORT: "brokerAddresses.address.stateId.name",
    PARENT_BROKER_PHONE_NUMBER_SORT_KEY: "tpaAddresses.address.phoneNumber",
    PARENT_BROKER_PHONE_NUMBER_SORT: "brokerAddresses.address.phoneNumber",
};
exports.POLICY_PLACED_TYPE = {
    SINGLE_INSURER: "SINGLE_INSURER",
    MULTIPLE_INSURER: "MULTIPLE_INSURER",
};
exports.DATA_VALIDATION_TASK_NAME = "Data Validation";
exports.PRIORITY_LOOK_UP_MEDIUM_VALUE = "PRIORITY_MEDIUM";
exports.PRIORITY_LOOK_UP_HIGH_VALUE = "PRIORITY_HIGH";
exports.ACTIVITY_APPROVAL_YES = "YES";
exports.MANDATE_TYPE_FULL_MANDATE = "MANDATE_TYPE_FULL_MANDATE";
exports.OPPORTUNITY_STATUS_OPEN = "OPPORTUNITY_STATUS_OPEN";
exports.OPPORTUNITY_STATUS_LOST = "OPPORTUNITY_STATUS_LOST";
exports.OPPORTUNITY_STATUS_WORK_IN_PROGRESS = "OPPORTUNITY_STATUS_WORK_IN_PROGRESS";
exports.TASK_CATEGORY_ACTIVITY = "TASK_CATEGORY_ACTIVITY";
exports.TASK_TYPE = {
    ACTIVITY: "TASK_TYPE_ACTIVITY",
    TASK: "TASK_TYPE_SUB_TASK",
    ASSIGNED: "TASK_TYPE_ASSIGNED",
    APPROVAL: "TASK_TYPE_APPROVAL",
};
exports.ACL_ACTIONS = {
    READ: "READ_001",
    WRITE: "WRITE_001",
    UPDATE: "UPDATE_001",
};
exports.ACL_CATEGORY = {
    OPPORTUNITY_ACTIVITY: "OPTY_ACTIVITY",
};
exports.TASK_STATUS_ACTIVE = "TASK_STATUS_ACTIVE";
exports.TASK_STATUS_CLOSED = "TASK_STATUS_CLOSED";
exports.TASK_TYPE_APPROVAL = "TASK_TYPE_APPROVAL";
exports.TASK_CLOSED = "TASK_CLOSED";
exports.CONTACT_MAP_TABLE_DELETE_FIELDS = {
    CONTACT_ADDRESS: "ContactAddress",
    CHILD_DETAILS: "ChildDetails",
    QUALIFICATION_EXPERIENCE: "QualificationExperience",
    PROFESSIONAL_EXPERIENCE: "ProfessionalExperience",
    COMMUNICATION_DETAILS: "ContactCommunicationDetails",
    ADDRESS_ID: "addressId",
    CONTACT_ID: "contactId",
    ID: "id",
};
exports.CONTACT_RECORD_TYPE_MAP = {
    COMPANY_CONTACT_RECORD_TYPE: "COMPANY_CONTACT",
    INSURER_CONTACT_RECORD_TYPE: "INSURER_CONTACT",
    TPA_CONTACT_RECORD_TYPE: "TPA_CONTACT",
    BROKER_CONTACT_RECORD_TYPE: "BROKER_CONTACT",
};
exports.FILE_UPLOAD_TABLE_DELETE_FIELDS = {
    FILE_UPLOAD: "FileUpload",
    ID: "id",
    DOCUMENT_ID: "documentId",
};
exports.COMPANY_MAP_TABLE_DELETE_FIELDS = {
    COMPANY_ADDRESS: "CompanyAddress",
    STATE_GST_DETAILS: "StateGstDetail",
    ADDRESS_ID: "addressId",
    COMPANY_ID: "companyId",
    ID: "id",
};
exports.BROKER_MAP_TABLE_DELETE_FIELDS = {
    BROKER_ADDRESS: "BrokerAddress",
    ADDRESS_ID: "addressId",
    BROKER_ID: "brokerId",
    ID: "id",
};
exports.TPA_MAP_TABLE_DELETE_FIELDS = {
    TPA_ADDRESS: "TpaAddress",
    ADDRESS_ID: "addressId",
    TPA_ID: "id",
    ID: "id",
};
exports.INSURER_MAP_TABLE_DELETE_FIELDS = {
    INSURER_ADDRESS: "InsurerAddress",
    ADDRESS_ID: "addressId",
    INSURER_ID: "insurerId",
    ID: "id",
};
exports.OPPORTUNITY_MAP_TABLE_DELETE_FIELDS = {
    POLICY_DOCKET_DOCUMENT_MAP: "PolicyDocketDocumentMap",
    DOCUMENT_ID: "documentId",
    ID: "id",
    POLICY_DOCKET_ID: "policyDocketId",
    HELD_COVER_NOTE_DOCUMENT_MAP: "HeldCoverNoteDocumentMap",
    POLICY_CONFIRMATION_DOCUMENT_MAP: "PolicyConfirmationDocumentMap",
    POLICY_HARD_COPY_DOCUMENT_MAP: "PolicyHardCopyDocumentMap",
    QUOTE_COMPARISON_DOCUMENT_MAP: "OpportunityQuoteComparisonReportDocumentMap",
    PREMIUM_CALCULATION_DOCUMENT_MAP: "OpportunityPremiumCalculationDocumentMap",
    OPPORTUNITY_QUOTE_DOCUMENT_MAP: "OpportunityQuoteDocumentMap",
};
exports.MEETING_SUBTYPE_KDM_KEY = "MEETING_SUBTYPE_KDM";
exports.MEETING_STATUS_SCHEDULED = "MEETING_STATUS_SCHEDULED";
exports.DEFAULT_KDM_MEETING_PURPOSE = "KDM Meeting";
exports.DEFAULT_HAND_OVER_MEET = "Hand Over Meet";
exports.DEFAULT_FINAL_NEGOTIATION_MEETING = "Final Negotiation Meeting";
exports.DEFAULT_RFP_DATA_COLLECTION = "RFP Data Collection";
exports.DEFAULT_RFP_DETAILS_ENTRY = "RFP Details Entry";
exports.DEFAULT_PLACEMENT_SLIP_GENERATION = "Placement Slip Generation";
exports.iirm = "iirm";
exports.PREMIUM_CALCULATION = "Premium Calculation";
exports.COVER_TYPE = {
    ASSET: "COVER_TYPE_ASSET",
    TOP_UP: "COVER_TYPE_TOP_UP",
    ADD_ON: "COVER_TYPE_ADD_ON",
    MAIN: "COVER_TYPE_MAIN",
};
exports.NOTIFICATION_EMAIL = "NOTIFICATION_CHANNEL_EMAIL";
exports.NOTIFICATION_SMS = "NOTIFICATION_CHANNEL_SMS";
exports.NOTIFICATION_IN_APP = "NOTIFICATION_CHANNEL_IN_APP";
exports.NOTIFICATION_SUCCESS = "NOTIFICATION_STATUS_SUCCESS";
exports.NOTIFICATION_FAILED = "NOTIFICATION_STATUS_FAILED";
exports.NOTIFICATION_STATUS_READ = "NOTIFICATION_READ";
exports.NOTIFICATION_STATUS_UNREAD = "NOTIFICATION_UNREAD";
exports.NOTIFICATION_STATUS_DELETE = "NOTIFICATION_DELETE";
exports.PASSWORD_RESET_EVENT = "Password_Reset";
exports.OPPORTUNITY_PARTICIPANT_INVITE = "Opportunity_Participant_Invite";
exports.PRIORITY_COMPANY_CREATION = "Priority_Company_Creation";
exports.COMPANY_SUM_INSURED_NOTIFICATION_THRESHOLD = 1000000000;
exports.OPTY_SUM_INSURED_NOTIFICATION_THRESHOLD = 100000000;
exports.NOTIFICATION_OPPORTUNITY_ENTITY = "opportunities";
exports.NOTIFICATION_COMPANY_ENTITY = "companies";
exports.PRIORITY_IMP = "PRIORITY_IMP";
exports.PRIORITY_HIGH = "PRIORITY_HIGH";
exports.PRIORITY_VIMP = "PRIORITY_VIMP";
exports.OPPORTUNITY_ACTIVITY_STATUS = {
    OPEN: "OPPORTUNITY_ACTIVITY_STATUS_OPEN",
    WORK_IN_PROGRESS: "OPPORTUNITY_ACTIVITY_STATUS_WORK_IN_PROGRESS",
    SUBMITTED: "OPPORTUNITY_ACTIVITY_STATUS_SUBMITTED",
    CLOSED: "OPPORTUNITY_ACTIVITY_STATUS_CLOSED",
};
exports.NOTIFICATION_EVENT_TYPES = {
    PRIORITY_COMPANY_CREATION: "Priority_Company_Creation",
    OPPORTUNITY_PARTICIPANT_INVITE: "Opportunity_Participant_Invite",
    PASSWORD_RESET_EVENT: "Password_Reset",
    HIGH_PREMIUM_COMPANY_CREATION: "High_Premium_Company_Creation",
    High_Value_Opportunity_Creation: "High_Value_Opportunity_Creation",
    OPPORTUNITY_CREATION: "Opportunity_Creation",
    OPPORTUNITY_LOST: "Opportunity_Lost",
    OPPORTUNITY_EXPIRATION: "Opportunity_Expiration",
    OPPORTUNITY_ACTIVITY_PLAN_DELAY: "Opportunity_Activity_Plan_Delay",
};
